import { render } from "./configuracion.vue?vue&type=template&id=47c3e1a8&scoped=true"
import script from "./configuracion.vue?vue&type=script&lang=js"
export * from "./configuracion.vue?vue&type=script&lang=js"

import "./configuracion.vue?vue&type=style&index=0&id=47c3e1a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c3e1a8"]])

export default __exports__